export * from "./RStatus";

export * from "./User";

export * from "./Machine";

export * from "./SubAccount";

export * from "./CurrentSub";

export * from "./MinerGroup";

export * from "./FundBalance";

export * from "./UserBalance";

export * from "./Summary";

export * from "./ObserverAccount";

export * from "./CommonBuilder";

export * from "./CurrentSetting";

export const DATE_FORMAT = "YYYY/MM/DD HH:mm:ss";
export const DATE_FORMAT_ACCURATE_TO_DAY = "YYYY/MM/DD";
export const DATE_TABLE_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const DATE_ABLE_FORMAT_DAY = "YYYY-MM-DD";
export const DATE_CHART_FORMAT = "YYYY-MM-DD HH:mm";

export enum MoneyUnit {
  cny = "cny",
  usd = "usd",
}

export enum MoneyFlag {
  cny = "¥",
  usd = "$",
}

export enum PowerPrice {
  cny = 0.38,
  usd = 0.07,
}

export enum CoinType {
  BSV = "BSV",
  BTC = "BTC",
  BCH = "BCH",
  "-" = "-",
  LTC = "LTC",
  DOGE = "DOGE",
}

export interface EchartSeries {
  name: string;
  type: string;
  data: number[];
  id?: string;
  areaStyle?: {};
}

export interface CurrencyCoinFee {
  size: string | number;
  tx: string | number;
  text: string;
  type: string;
}

export interface ExchangeRate {
  btc_exchange_bsv_rate: number;
  estimate_rate_bsv_to_btc: number;
  estimate_rate_btc_to_bsv: string;
  is_btc_exchange_bsv: number;
}

export interface EarnData {
  bsv_earn: string;
  bsv_earn_tran: string;
  btc_earn: string;
  btc_earn_tran: string;
}

// 0费率活动
export interface ZeroRate {
  isZeroRate: boolean;
  startTime: string;
  endTime: string;
}

export enum Pool {
  Mempool = "mempool",
  Nourpool = "nourpool",
  Exatoshi = "exatoshi",
}

export interface FundSummary {
  bsv_balance: number;
  btc_balance: number;
  bsv_yestoday_profit: number;
  btc_yestoday_profit: number;
  bsv_total_profit: number;
  btc_total_profit: number;
  bsv_funds_balance: number;
  btc_funds_balance: number;
}

export interface powerChart {
  x: number[];
  y_btc: number[];
  y_bsv: number[];
  y_ltc: number[];
  y_total: number[];
}

export interface minerChart {
  x: number[];
  y: number[];
}

export interface earnChart {
  x: number[];
  y_btc: number[];
  y_bsv: number[];
  y_ltc: number[];
}

export interface NoticeInfo {
  title: "";
  en_title: "";
  link: "";
  en_link: "";
}

export enum OAuthCode {
  BindAccount = 64227, // 需要绑定手机或邮箱
  SetLoginPassword = 64005, // 需要设置登录密码
  LoginEnvAbnormal = 64231, // 新设备首次登录需要输入验证码
  LoginEnvAbnormalError = 64221, // 新设备首次登录需要输入验证码
  Frozen2Hours = 64232, // 账号已被冻结，请2小时后重试
  Frozen1Day = 64233, // 账号已被冻结，请24小时后重试
  PayPassword = 10180006, // 自动支付划转和订单支付密码错误或者需要支付密码
  VerifyCode = 10180013, // 自动支付划转和订单支付需要验证码
}
